import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { NeoCiudadClienteDTO } from '../Model/neoCiudadClienteDTO';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

const API_URL = environment.apiLocalUrl + 'neoCiudadCliente';
@Injectable({
  providedIn: 'root',
})
export class CiudadClienteService {
  constructor(private _http: HttpClient) {}

  saveCiudadesCliente(
    ciudadesCliente: NeoCiudadClienteDTO[]
  ): Observable<NeoCiudadClienteDTO[]> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post<NeoCiudadClienteDTO[]>(API_URL, ciudadesCliente, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }
  deleteCiudadCliente(idCiudadCliente): Observable<any> {
    return this._http.delete<any>(`${API_URL}/${idCiudadCliente}`).pipe(catchError(HandleHttpError));
  }

  getCiudadClientePorId(idCiudadCliente): Observable<NeoCiudadClienteDTO> {
    return this._http.get<NeoCiudadClienteDTO>(`${API_URL}/${idCiudadCliente}`).pipe(catchError(HandleHttpError));
  }

  updateCiudadCliente(
    ciudadCliente: NeoCiudadClienteDTO
  ): Observable<NeoCiudadClienteDTO> {
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.put<NeoCiudadClienteDTO>(API_URL, ciudadCliente, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }
}
